function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "smartphone_vibration"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21.192 7.051-4.243-4.243c-1.129-1.129-3.113-1.129-4.242 0l-9.899 9.899c-1.17 1.17-1.17 3.072 0 4.242l4.243 4.243c.564.564 1.318.876 2.121.876s1.557-.312 2.121-.876l9.899-9.899c1.17-1.17 1.17-3.072 0-4.242zm-1.414 2.828-9.899 9.899c-.375.373-1.039.373-1.414 0l-4.243-4.243c-.39-.39-.39-1.024 0-1.414l9.899-9.899c.188-.187.438-.29.707-.29s.52.104.707.29l4.243 4.243c.39.389.39 1.024 0 1.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 9c.256 0 .512-.098.707-.293l4-4c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-4 4c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 16,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.315 15.514-4 3.758c-.402.378-.423 1.011-.044 1.413.197.21.462.315.729.315.246 0 .491-.09.685-.271l4-3.758c.402-.378.423-1.011.044-1.413-.377-.404-1.01-.421-1.414-.044z"
})));

var Svg108Smartphone = function Svg108Smartphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg108Smartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/108-smartphone.daf3b178.svg";
export { ForwardRef as ReactComponent };